<template>
   <QSelect
      :model-value="analyticsStore.utmSource"
      class="col-grow"
      label="UTM Source"
      :options="utmSourceOptions"
      use-input
      hide-selected
      fill-input
      @filter="onUtmSourceFilter"
      @popup-show="loadUtmSources"
      @update:model-value="handleUtmSourceChange"
   />
</template>

<script setup lang="ts">
import { ref } from "vue"
import { useAnalyticsStore } from "@stores/analyticsStore"
import { ALL_UTM_SOURCES_OPTION } from "@/utils/constants"

const analyticsStore = useAnalyticsStore()
const utmSourceOptions = ref<string[]>([])

const handleUtmSourceChange = (value: string) => {
   analyticsStore.utmSource = value
}

const onUtmSourceFilter = async (
   val: string,
   update: (callback: () => void) => void,
) => {
   if (val === "") {
      const sources = await analyticsStore.loadUtmSources()
      update(() => {
         utmSourceOptions.value = sources
      })
      return
   }
   const sources = await analyticsStore.loadUtmSourcesAc(val)
   update(() => {
      utmSourceOptions.value = sources
   })
}

const loadUtmSources = async () => {
   const sources = await analyticsStore.loadUtmSources()
   sources.unshift(ALL_UTM_SOURCES_OPTION)
   utmSourceOptions.value = sources
}
</script>
<style lang="scss" scoped>
.q-select {
   min-width: 100px;
   max-width: 200px;
}
</style>
